import { Link } from 'react-router-dom';
import Login from '../pages/login/login';
import Components from '../pages/components/components';
import ForgotPassword from '../pages/forgotPassword/forgotPassword';
import OtpVerification from '../pages/otpVerification/otpVerification';
import ResetPassword from '../pages/resetPassword/resetPassword';
import TrailDetail from '../pages/trails/trailDetail/trailDetail';
import Trails from '../pages/trails/trails';
import AddTrail from '../pages/addTrail/addTrail';
import SuggestedTrails from '../pages/suggestedTrails/suggestedTrails';
import SuggestedTrailDetail from '../pages/suggestedTrails/suggestedTrailDetail/suggestedTrailDetail';
import ChangePassword from '../pages/changePassword/changePassword';

const authProtectedRoutes = [
    { path: "/", exact: true, component: () => <Link to="/dashboard" /> },
    { path: "/trails", element: <Trails /> },
    { path: "/suggested-trails", element: <SuggestedTrails /> },
    { path: "/trails/trail-detail/:id", element: <TrailDetail /> },
    { path: "/suggested-trails/suggested-trail-detail/:id", element: <SuggestedTrailDetail /> },
    { path: "/add-trail", element: <AddTrail /> },
    { path: "/edit-trail/:id", element: <AddTrail /> },
    { path: "/change-password", element: <ChangePassword /> },
];

const publicRoutes = [
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    { path: "/components", element: <Components /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/otp-verification", element: <OtpVerification /> },
    { path: "/reset-password", element: <ResetPassword /> },
];

export { authProtectedRoutes, publicRoutes }